/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon64Regular = forwardRef('ArrowDCornerUpLeftIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M25.44 5.672a1.5 1.5 0 1 1 2.12 2.122L12.623 22.732a2.518 2.518 0 0 0-.232.268H43.5a9.5 9.5 0 0 1 9.5 9.5v24a1.5 1.5 0 1 1-3 0v-24a6.5 6.5 0 0 0-6.5-6.5H12.39c.07.093.147.183.232.268l14.939 14.938a1.5 1.5 0 1 1-2.121 2.121L10.5 28.39a5.5 5.5 0 0 1 0-7.778L25.44 5.672Z" })));
});
